module.exports = __webpack_public_path__ + "assets/img/UnionRankingList.b16d6c79.png";